import { render, staticRenderFns } from "./WalletBalanceCard.vue?vue&type=template&id=1a25fc3a"
import script from "./WalletBalanceCard.vue?vue&type=script&lang=js"
export * from "./WalletBalanceCard.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports